export default __webpack_public_path__ + "static/media/threeDotsHC.02a288f8.svg";